import styled from "@emotion/styled";
import { Box, Button as MuiButton } from "@mui/material";

import { theme } from "../../mui-customs/Theme";

export const StyledAmountContainer = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  p:nth-child(1) {
    color: ${theme.grey1[400]};
  }
  p:nth-child(2) {
    color: ${theme.black[800]};
  }
`;
